import styled from 'styled-components';
import { cardShadow } from '../../../theme';

export const StatusCardContainer = styled.button<{ $isActive?: boolean; $isClickable?: boolean }>`
  /* button reset */
  appearance: none;
  border: none;
  font: inherit;
  margin: 0;
  text-align: left;
  width: 100%;

  /* layout */
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.spacing(2)};
  ${cardShadow}

  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};

  background-color: ${({ theme: { palette, color }, $isActive }) => {
    if ($isActive) return palette.mode === 'dark' ? color.backgroundSelectedHover : color.hoverGray;
    return palette.mode === 'dark' ? color.backgroundPaperDark : color.white;
  }};

  outline: 2px solid
    ${({ theme: { palette, color }, $isActive }) => {
      if ($isActive) return palette.mode === 'dark' ? color.white : color.primary;
      return 'transparent';
    }};
  transition: background-color 0.15s ease, outline-color 0s;

  &:hover {
    background-color: ${({ theme: { palette, color }, $isActive, $isClickable }) => {
      if (!$isClickable || $isActive) return undefined;
      return palette.mode === 'dark' ? color.backgroundSelectedDark : color.backgroundTableHeader;
    }};
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme: { palette, color } }) => (palette.mode === 'dark' ? color.white : color.primary)};
    outline-offset: 3px;
  }

  & > :first-child {
    flex: 1;
  }
`;
